import {Label} from '@primer/react'

import labelStyles from '../../stack-section/EntryStatusLabel.module.css'
import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function SkippedLabel({state}: {state?: RebaseState}) {
  if (state !== RebaseState.Skipped) return null

  return (
    <Label variant="secondary" className={labelStyles.solid}>
      Skipped
    </Label>
  )
}
